import * as React from "react";
import ClustersTable from "../tables/ClustersTable";
import ClustersFilter from "../filters/ClustersFilter";
import { Stack } from "@mui/material";
import { useHasScope } from "../../../../../config/globalConfig";
import { VIEW_CLUSTERS } from "../../../utils/FinanceScope";
import NotAuthorizedDialog from "../../../../authentication/component/NotAuthorizedDialog";

function Clusters() {

    const hasScope = useHasScope;

    if (!hasScope(VIEW_CLUSTERS)) return <NotAuthorizedDialog />;

    return (
        <Stack direction={"column"} spacing={2} margin={"16px"}>
            <ClustersFilter/>
            <ClustersTable/>
        </Stack>
    )
}

export default Clusters;